<template>
  <div class="menuWrapper">
    <div :class="['leftmenu', $store.state.leftmenu ? '' : 'hidemenu']">
      <div style="width: 100%; margin: 0 auto; height: 100%;">
        <div class="leftlogo flexStart">
          <!-- <div class="thumbnail flexCenter">
            <el-image style="width: 100%; height: 100%" :src="$store.state.config.applogo" fit="cover"></el-image>
          </div> -->
          <div v-if="$store.state.leftmenu" class="schoolName overMoreLine">{{ $store.state.config.schoolName_z ||
            '校企招聘平台'
            }}</div>
        </div>
        <div class="" style="width:100%;padding:16px 0">
          <el-menu router :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen"
            @close="handleClose" :collapse="isCollapse" background-color="#001529" text-color="#fff"
            active-text-color="#fff">
            <el-menu-item v-for="(item, idx) in Menus" :key="idx" :index="item.path">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </el-menu>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      defaultActive: '/home',
      enterInfo: {
        enterStatus: 0,
        enterName: ""
      },
      Menus: [
        { id: 1, title: '职位管理', path: '/home', icon: 'el-icon-setting', },
        { id: 2, title: '推荐简历', path: '/tjjl', icon: 'el-icon-tickets', },
        { id: 3, title: '收到的简历', path: '/sddjl', icon: 'el-icon-s-claim', },
        { id: 4, title: '邀请简历', path: '/yqjl', icon: 'el-icon-s-claim', },
        { id: 5, title: '企业资料', path: '/enterInfo', icon: 'el-icon-s-claim', },
        { id: 6, title: '线下招聘会', path: '/xxzph', icon: 'el-icon-s-management', },

        // { id: 6, title: '企业宣讲会', path: '/qyxjh', icon: 'el-icon-s-management', },

        { id: 7, title: '实习学生', path: '/sx_stus', icon: 'el-icon-user-solid', },
      ],



      nowsMenu: '',
      isCollapse: false,
    };
  },

  watch: {
    $route: function (n, o) {
      this.defaultActive = n.path;
    },
    Menus: function (n, o) {
      console.log(111, n, o)
      this.$parent.leftMenus = n;
    },

    "$store.state.leftmenu"(n, o) {
      console.log(222, n, o);
      if (n == 1) {
        this.isCollapse = false
      } else {
        this.isCollapse = true

      }
      this.$forceUpdate()
    }


  },
  mounted() {
    if (this.$route.path) {
      this.Menus.map(a => {
        if (a.path == this.$route.path) {
          this.nowsMenu = a.id
        }
      })
    } else {
      this.nowsMenu = this.Menus[0].id
    }
    this.$store.dispatch("showSmenu", 1)
    this.$store.dispatch("smenuCount", this.Menus.length)
    this.defaultActive = this.$route.path;

    this.$http.post("/api/enterprise_info", {}).then(res => {
      this.enterInfo.enterName = res.data.firm_name;
      this.enterInfo.enterStatus = res.data.check_status;
      if (res.data.pmid == 219) {
        this.Menus.push(
          { id: 8, title: '实习企业考察报告', path: '/sxqyResearcreport', icon: 'el-icon-document', },
        )
        this.$store.dispatch("smenuCount", this.Menus.length)

      }
    });
  },
  methods: {

    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },

  }
};
</script>


<style lang="less" type="text/less">
.menuWrapper {
  .el-menu {
    border-right: 0;

    .is-active {
      background-color: #3378FA !important;

    }

    .is-active,
    .is-active i {
      font-size: 18px;
      font-weight: 700;
    }
  }
}
</style>
<style scoped lang="less" type="text/less">
.menuWrapper {
  .leftmenu {
    width: 256px;
    height: 100%;
    position: absolute;

    transition: all .3s;
    transform-origin: left;
    background-color: #001529;
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);

    .leftlogo {
      padding: 0 20px;
      width: 100%;
      height: 64px;
      background-color: #002140;

      .thumbnail {
        width: 32px;
        min-width: 32px;
        height: 32px;
        overflow: hidden;
      }

      .schoolName {
        margin-left: 5px;
        font-family: STHupo;
        color: #fff;
        font-size: 16px;
      }
    }

    .menuitem {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      text-align: left;

      cursor: pointer;
      margin: 0 auto;

      font-size: 14px;
      color: #879DF5;
      font-weight: bolder;
    }

    .menuckd {
      color: #3D62F6;
    }
  }

  .hidemenu {
    /*transform: scale(0, 1);*/
    width: 64px;
  }

  .smenubox {
    width: 200px;
    padding-left: 10px;
    padding-top: 30px;
    margin: 0 auto;
    background-color: #fff;
    height: 95%;
    box-shadow: 2px 2px 6px 2px rgba(24, 144, 255, 0.1);

    .el-menu {
      border: 0;
    }

    .el-submenu__title {
      background-color: transparent !important;
    }
  }


  .menuckd {

    color: #1890ff;
    box-shadow: 0 0 6px 2px rgba(24, 144, 255, 0.2) inset;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    transform: translateX(10px);
    position: relative;
    background-color: #fafbfc;
  }

  .menuckd .ckdtail {
    width: 40px;
    height: 80px;
    position: absolute;
    top: -20px;
    right: -5px;
    background-image: url('/public/img/tail.png');
    background-size: auto 98%;

    background-repeat: no-repeat;
    background-color: #fafbfc;



  }
}













.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  height: 100%;
}

.leftmenu {
  width: 13%;
  height: 100%;
  position: absolute;
  transition: all 0.3s;
  transform-origin: left;
}

.collapse {
  width: 70px;
}
</style>
